import { render } from "./InSheepsClothing.vue?vue&type=template&id=ae695b26&scoped=true&ts=true"
import script from "./InSheepsClothing.vue?vue&type=script&lang=ts"
export * from "./InSheepsClothing.vue?vue&type=script&lang=ts"

import "./InSheepsClothing.vue?vue&type=style&index=0&id=ae695b26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae695b26"]])

export default __exports__